module.exports = __webpack_public_path__ + "static/Metropolis-SemiBold-467c126d0b6844c4a39a62ef26118d0e.woff";